import { render, staticRenderFns } from "./BaseLoaderModal.vue?vue&type=template&id=3b5008c7&scoped=true&"
import script from "./BaseLoaderModal.vue?vue&type=script&lang=js&"
export * from "./BaseLoaderModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoaderModal.vue?vue&type=style&index=0&id=3b5008c7&prod&lang=css&"
import style1 from "./BaseLoaderModal.vue?vue&type=style&index=1&id=3b5008c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5008c7",
  null
  
)

export default component.exports